import { Button, Drawer, Skeleton } from "antd";
import { DollarCircleOutlined } from "@ant-design/icons";
import { Suspense, lazy, useState } from "react";
import { usePaymentProcessor } from "auth/usePaymentProcessor";

const PayoutReport = lazy(() => import("./PayoutReport"));

/** Button to display the Stripe payout report. */
export const PayoutReportButton = () => {
    const isStripe = usePaymentProcessor() === "Stripe";

    return isStripe ? <PayoutReportButtonActive /> : null;
};

// Implementation for the case where we actually have the button
const PayoutReportButtonActive = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button style={{ marginRight: "1em" }} onClick={() => setOpen(!open)}>
                <DollarCircleOutlined />
                Payouts
            </Button>
            <Drawer title="Payouts" placement="right" size="large" open={open} onClose={() => setOpen(false)}>
                <Suspense fallback={<Skeleton active />}>
                    <PayoutReport />
                </Suspense>
            </Drawer>
        </>
    );
};
